import React, { useEffect, useState } from 'react'
import LazySection from '../../../Pages/Home/LazySection'
import BasicDetails from '../Astrology/BasicDetails'

import './horosopepage.css'
import Breadcrumbs from '../../Breadcrumb'
import HoroscopeBannerImg from "../../../assets/images/new/HoroscopeBanner.png";
import DailyPrediction from '../DaliyPrediction/DailyPrediction'
import Numerology from '../Numerology/Numerology'
import Prediction from '../Prediction/Prediction'
import { Helmet } from "react-helmet-async";
import astrology from "../../../assets/images/new/astrology.png";
import panchang from "../../../assets/images/new/panchang.png";
import numerology from "../../../assets/images/new/numerology.png";
import zodiacSign from "../../../assets/images/new/zodiacSign.png";

import { useLocation, useNavigate } from 'react-router-dom'
import { t } from 'i18next'
import toast from 'react-hot-toast'
import { GetProfileDetails, GetUserModel } from '../../../ApiServices/Profile/ProfileApi'

const CommonHoroscopePage = () => {
  const navigate = useNavigate();
  const ItemAddedToast = () => toast("Please Update Your Profile");
  const location = useLocation()
  const [activeCategory, setActiveCategory] = useState("BasicDetails")
  const [metaDesc, setMetaDesc] = useState("Explore authentic Vedic astrology with Myomnamo. Get daily, weekly & monthly horoscopes, personalized birth chart readings, rashifal insights, and numerology ");
  const [metaTitle, setMetaTitle] = useState("Book Astrology & Horoscope Services Online |  Myomnamo");
  const categories = [
    {
      title: t("Astrology"),
      ID: "BasicDetails",
      icon: astrology,
      text: "Book Astrology for your spiritual rituals and ceremonies.",
      color: "#ffa415",
    },
    {
      title: t("Numerology"),
      ID: "Numerology",
      icon: numerology,
      text: "Numerology for better life",
      color: "#8139e7",
    },
    {
      title: t("Panchang"),
      ID: "Panchang",
      icon: panchang,
      text: "Get a Panchang for your up and down ",
      color: "#fc5528",
    },

    {
      title: t("Zodiac Signs"),
      ID: "ZodiacSigns",
      icon: zodiacSign,
      text: "Know about Zodiac Prediction",
      color: "#399be7",
    }
  ];

  useEffect(() => {
    GetUserModelData();
  }, []);


  const handleCategoryClick = (id) => {

    setActiveCategory(id)
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const GetUserModelData = async () => {

    const userKeyID = localStorage.getItem("userKeyID");
    try {
      const response = await GetProfileDetails(userKeyID);
      if (response?.statusCode === 200) {
        // setLoader(false);

        const ModelData = response?.responseData?.data || []; // Assuming the data is an array and we need the first item
        if (
          ModelData?.dob === null ||
          ModelData?.dob === undefined ||
          ModelData?.dob === ""
        ) {
          toast("Please Update Your Profile");
          setTimeout(() => {
            navigate("/my-profile", {
              state: { modelName: "Horoscope" },
            });
          }, 500);
        }
      } else {
        // setLoader(false);
        toast("Please Update Your Profile");
        setTimeout(() => {
          navigate("/my-profile", {
            state: { modelName: "Horoscope" },
          });
        }, 500);
        console.error(
          "Error fetching data: ",
          response?.data?.data?.statusCode
        );
      }
    } catch (error) {
      // setLoader(false);

      console.error("Error", error);
    }
  };


  return (
    <>
      <Helmet>
        <title>
          {metaTitle}
        </title>
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta
          name="description"
          content={metaDesc}
        />
        <meta
          property="og:title"
          content={metaTitle}
        />
        <meta
          property="og:description"
          content={metaDesc}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={metaTitle}
        />
        <meta
          name="twitter:description"
          content={metaDesc}
        />

      </Helmet>
      <section className="page-header" style={{ paddingBottom: '28px' }}>
        <div
          className="page-header__bg horoscope-banner-responsive"
          style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
        ></div>
        <div className="container" style={{ display: 'block' }}>
          <h2 className="page-header__title bw-split-in-left">{t("Astro Details")}</h2>
          <div className='d-flex justify-content-center'>
            <Breadcrumbs />
          </div>
        </div>
      </section>

      <div className="container  astro-carosal " style={{ marginTop: '50px' }}>
        {/* Category Tabs (Mobile view) */}
        <div className="d-flex d-md-none overflow-auto px-2" >
          {categories.map((category, index) => (
            <div
              key={index}
              className="text-center me-3 flex-shrink-0"
              style={{ width: "100px", cursor: "pointer" }}
              onClick={() => handleCategoryClick(category.ID)} // 👈 scroll on click
            >
              <div
                className="rounded-circle bg-white shadow d-flex align-items-center justify-content-center mx-auto"
                style={{ width: "70px", height: "70px" }}
              >
                <img
                  src={category.icon}
                  alt={category.title}
                  style={{
                    maxWidth: "50px",
                    maxHeight: "50px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <p
                className="mt-2 fw-semibold"
                style={{
                  color:
                    category?.ID === activeCategory ? "#b99e18" : "#a52444",
                }}
              >
                {category.title}
              </p>
            </div>
          ))}
        </div>


        <div
          className="row justify-content-center text-center g-4 d-none d-md-flex"
          style={{
            backgroundColor: "#a4264221",
            borderRadius: "79px",
            padding: "9px 0px 9px 0px"
          }}
        >
          {categories.map((category, index) => (
            <div
              key={index}
              className="col-6 col-sm-4 col-md-3"
              style={{ cursor: "pointer", marginTop: '0px' }}
              onClick={() => handleCategoryClick(category.ID)} // 👈 scroll on click
            >
              <div
                className="rounded-circle bg-white shadow d-flex align-items-center justify-content-center mx-auto"
                style={{ width: "45px", height: "45px" }}
              >
                <img
                  src={category.icon}
                  alt={category.title}
                  style={{
                    maxWidth: "40px",
                    maxHeight: "40px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <p
                className="mt-2 fw-semibold"
                style={{
                  color:
                    category?.ID === activeCategory ? "#b99e18" : "#a52444",
                  marginBottom: "0px",
                  fontSize: "16px"
                }}
              >
                {category.title}
              </p>
            </div>
          ))}
        </div>

      </div>


      {/* Sections */}
      <LazySection id="BasicDetails"><BasicDetails /></LazySection>
      <LazySection id="Numerology"><Numerology /></LazySection>
      <LazySection id="Panchang"><DailyPrediction /></LazySection>
      <LazySection id="ZodiacSigns"><Prediction /></LazySection>

    </>
  )
}

export default CommonHoroscopePage
